module.exports = __webpack_public_path__ + "fonts/open-sans-v15-cyrillic-regular.ca41c45.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/open-sans-v15-cyrillic-regular.woff2
// module id = vHca
// module chunks = 13